const FALLBACK_FLAG = "fb";

export const isNetworkLevelError = (error) =>
  !!error && !error.response;

// Returns true if a redirect was triggered (caller can stop further work).
export const redirectToCanonicalCheckout = () => {
  try {
    const canonical = process.env.REACT_APP_CANONICAL_CHECKOUT_URL;
    // Feature is off unless a canonical URL is configured for this build.
    if (!canonical) return false;

    const canonicalUrl = new URL(canonical);
    const current = new URL(window.location.href);

    // Guard 1: already on the canonical domain — do nothing (prevents loop).
    if (current.origin === canonicalUrl.origin) return false;

    // Guard 2: already redirected once — do nothing (prevents loop).
    if (current.searchParams.get(FALLBACK_FLAG) === "1") return false;

    // Nothing to carry over without a token.
    const token = current.searchParams.get("token");
    if (!token) return false;

    // Preserve every existing query param, add the fallback marker so the
    // canonical page knows this was a fallback and never bounces again.
    const params = new URLSearchParams(current.search);
    params.set(FALLBACK_FLAG, "1");

    // replace() so the broken vanity URL is not left in history (no back-loop).
    window.location.replace(`${canonicalUrl.origin}/?${params.toString()}`);
    return true;
  } catch (e) {
    // Never let the fallback logic itself break the error flow.
    return false;
  }
};
